module.exports = __webpack_public_path__ + "static/media/ibm.a564bf20.png";